export const ALL_PRODUCTS_OPTION = 'All Products';

export const WEBINAR_REDIRICTION_SECTION_COPY = {
  head: 'Sign up for a webinar today',
  description:
    'We also conduct webinars across topics to help you get started.',
  buttonText: 'Register now',
  buttonLink: 'https://cleartax.in/webinars/',
};

export const UPDATE_SUBSCRIPTION_COPY = 'Get updates on Email and Phone';

export const UPTICK_COLOR = '#9092A3';

export const RECAPTCHA_SITE_KEY = {
  commonLead: '6LevgAErAAAAAKzR-MPcdXwti7lpxV3-jOPM0vL2',
  chatKey: '6LdCsPspAAAAAJRxYr_sQkwyY4_2nXVkiz6uo4YN',
};
